import React from "react";
import { Box, Grid, styled, Typography } from "@mui/material";
import digitalPng from "../../../../resources/images/png/home/digital.png";
import { ReactComponent as DigitalBackground } from "../../../../resources/images/svg/home/digitalBackground.svg";
import InexCard from "../../../InexCard";
import { CardGiftcardRounded } from "@mui/icons-material";
import { CTAButton } from "../odyssee/OdysseeCard";
import { useIsMobile } from "../../../../hooks/responsive";

export const DigitalImage = styled("img")(({ theme }) => {
	return {
		position: "absolute",
		top: 0,
		left: 0,
		height: "95%",
		transform: "translate(10%, 5%)",
		objectFit: "contain",
		maxWidth: "90%",
	};
});

export const Title = styled(Typography)(({ theme }) => {
	return {
		fontSize: "30px",
		fontFamily: "Branding Bold",
		color: theme.palette.secondary.main,
	};
});

export const Description = styled(Typography)(({ theme }) => {
	return {
		marginTop: theme.spacing(1),
		fontSize: "16px",
		fontFamily: "Branding Medium",
		color: theme.palette.secondary.main,
		marginRight: theme.spacing(1),
	};
});

export const PriceContainer = styled(Box)(({ theme }) => {
	return {
		display: "flex",
		flexDirection: "column",
		backgroundColor: "#FFFFFF4D",
		padding: theme.spacing(2),
		marginTop: 20,
	};
});

const DigitalBlock = ({}) => {
	const isMobile = useIsMobile();

	const link = "https://abonnements.inexplore.com/offrir?selectedAbos=[4]";

	return (
		<InexCard
			sx={{
				position: "relative",
				paddingTop: 0,
				paddingBottom: 0,
				padding: 0,
				boxShadow: (theme) => theme.shadows[26],
				zIndex: 0,
			}}
		>
			<DigitalBackground
				style={{
					position: "absolute",
					bottom: 0,
					left: 0,
				}}
			/>
			<Grid
				container
				sx={{
					backgroundColor: "#C7C4DE",
					zIndex: 1,
				}}
			>
				<Grid item xs={3}>
					<Box
						sx={{
							position: "relative",
							width: "100%",
							height: "100%",
							minHeight: "150px",
							overflow: "hidden",
						}}
					>
						<DigitalImage src={digitalPng} alt="Digital Png" />
					</Box>
				</Grid>
				<Grid
					item
					xs={9}
					sm={6}
					md={7}
					sx={{
						zIndex: 1,
					}}
				>
					<Box
						pl={isMobile ? 2 : 0}
						pt={4}
						pb={4}
						sx={{
							display: "flex",
							justifyContent: "center",
							flexDirection: "column",
							height: "100%",
						}}
					>
						<Title>Inexploré Praticiens</Title>
						<Description>
							Offrez un abonnement de 6 mois à la plateforme Inexploré Praticiens pour écouter les podcasts praticiens, 
							s'incrire aux évènements (cercles, ateliers, ...) + tout l’univers Inexploré TV + digital.
						</Description>
						{!isMobile && (
							<Box
								sx={{
									marginTop: (theme) => theme.spacing(1),
								}}
							>
								<a target="_blank" href={link}>
									<CTAButton
										variant={"texticon"}
										icon={
											<CardGiftcardRounded
												sx={{
													fontSize: "26px",
													color: (theme) => theme.palette.secondary.main,
												}}
											/>
										}
										textWithGradient={false}
										disableBackground={true}
										text={"Offrir une carte cadeau Inexploré Praticiens"}
										sx={{
											minWidth: 230,
											padding: 3.5,
											flexDirection: "row-reverse",
											backgroundColor: "#F1C555",
										}}
										textSx={{
											textTransform: "none",
										}}
									/>
								</a>
							</Box>
						)}
					</Box>
				</Grid>
				<Grid
					xs={12}
					sm={3}
					md={2}
					sx={{
						zIndex: 1,
					}}
				>
					<PriceContainer
						sx={{
							marginTop: isMobile ? 0 : "20px",
						}}
					>
						<Typography
							sx={{
								fontSize: "16px",
								fontFamily: "Branding Semibold",
								color: (theme) => theme.palette.secondary.main,
							}}
						>
							6 mois d'abonnement
						</Typography>
						<Typography
							sx={{
								fontSize: "30px",
								fontFamily: "Branding Bold",
								color: (theme) => theme.palette.secondary.main,
							}}
						>
							107,00€
						</Typography>
					</PriceContainer>
				</Grid>
				{isMobile && (
					<Grid
						xs={12}
						m={2}
						sx={{
							zIndex: 1,
						}}
					>
						<Box
							sx={{
								marginTop: (theme) => theme.spacing(1),
							}}
						>
							<a target="_blank" href={link}>
								<CTAButton
									variant={"texticon"}
									icon={
										<CardGiftcardRounded
											sx={{
												fontSize: "26px",
												color: (theme) => theme.palette.secondary.main,
											}}
										/>
									}
									textWithGradient={false}
									disableBackground={true}
									text={"Offrir une carte cadeau Inexploré Praticiens"}
									sx={{
										width: "100%",
										minWidth: 230,
										padding: 3.5,
										flexDirection: "row-reverse",
										backgroundColor: "#F1C555",
									}}
									textSx={{
										textTransform: "none",
									}}
								/>
							</a>
						</Box>
					</Grid>
				)}
			</Grid>
		</InexCard>
	);
};

export default DigitalBlock;
